var sb = require('@sb/util')
import store from '@sb/store'
let bowser = require('bowser')

export default {
	props: ['isShow'],
	data () {
		return {
			previewEvent: {},
			previewClosed: false,
			isGreeting: true,
			...store.bind(this, ['account', 'agentM', 'convoEventM', 'accountSetting', 'user']),
		}
	},

	watch: {
		accountSetting (n) {
			this.loadGreeting()
		},
	},

	created () {
		var greeting = this.loadGreeting()
		if (!greeting) this.previewClosed = true
	},

	mounted () {
		store.onConvoEvent(this, ev => {
			if (sb.get(ev, 'type') !== 'message_sent') return

			// TODO: by agent only
			this.previewClosed = false // show preview

			let bytype = sb.get(ev, 'by.type')
			if (bytype !== 'system' && bytype !== 'agent') return
			this.previewEvent = ev
		})
	},

	render () {
		if (!this.isShow) return <transition name="fade" />

		return (
			<transition name="fade">
				<div>
					{this.renderButton()}
					{this.renderPreview()}
				</div>
			</transition>
		)
	},

	methods: {
		loadGreeting () {
			let greeting = sb.get(this.accountSetting, 'greeting', {})
			if (!greeting.message) return

			let byid = greeting.agent_id
			if (!byid) byid = randomAgent(this.agentM).id
			this.previewEvent = {
				by: { id: byid, type: 'agent' },
				data: { message: { text: greeting.message, format: 'plaintext' } },
			}
			return this.previewEvent
		},

		onClick () {
			// if has preview => click on button same as preview
			if (!this.previewClosed && sb.get(this.previewEvent, 'data.message.text')) {
				this.$emit('previewClicked', sb.convoKeyOfEv(this.previewEvent))
				return
			}
			this.$emit('click')
		},

		onPreviewClick () {
			this.$emit('previewClicked', sb.convoKeyOfEv(this.previewEvent))
		},

		renderUnread () {
			var unreadcount = sb.size(sb.filter(this.convoEventM, events => !sb.isConvoSeen(this.user.id, events)))
			if (unreadcount === 0) return null
			return <div class="chat-button--unread">{unreadcount}</div>
		},

		renderPreview () {
			return <transition name="slide-fade">{this.renderPreviewNoTransition()}</transition>
		},

		renderButton () {
			var defstyle =
				sb.get(this.accountSetting, 'desktop_button.default_style', false) ||
				!sb.get(this.accountSetting, 'desktop_button.background_image_url')
			var imgsrc = sb.get(this.accountSetting, 'desktop_button.background_image_url')

			if (bowser.mobile) {
				defstyle =
					sb.get(this.accountSetting, 'mobile_button.default_style', false) ||
					!sb.get(this.accountSetting, 'mobile_button.background_image_url')
				imgsrc = sb.get(this.accountSetting, 'mobile_button.background_image_url')
			}

			if (defstyle) {
				return (
					<div class="chat-button chat-button--default" vOn:click={this.onClick}>
						<div class="chat-button--logo" />
						{this.renderUnread()}
					</div>
				)
			}

			return (
				<div class="chat-button" vOn:click={this.onClick}>
					<img class="chat-button--img" src={imgsrc} />
					{this.renderUnread()}
				</div>
			)
		},

		renderPreviewNoTransition () {
			if (this.previewClosed) return null

			let byid = sb.get(this.previewEvent, 'by.display_id', sb.get(this.previewEvent, 'by.id'))
			let agent = sb.cloneDeep(this.agentM[byid]) || {}

			agent.fullname = agent.fullname || sb.get(this.account, 'name') || this.$t('agent')

			agent.avatar_url =
				agent.avatar_url || sb.get(this.account, 'logo_url') || require('../../assets/img/default_avatar.png')

			var tags = this.renderMessagePreview(this.previewEvent, this.$t('sent_you_a_message'))

			if (sb.size(tags) === 0) return null

			return (
				<div class="widget-preview">
					<div class="d-flex flex-row pl-3 pt-3 pr-3 pb-3">
						<img class="widget-preview--avatar" src={agent.avatar_url} />
						<div class="widget-preview--content" vOn:click={this.onPreviewClick}>
							<h5 class="widget-preview--title">{agent.fullname}</h5>

							<p class="widget-preview--message">{tags}</p>
						</div>
						<div class="widget-preview--btn-close" vOn:click_stop_prevent={this.closePreview} />
					</div>

					<div class="widget-preview--action" vOn:click={this.onPreviewClick}>
						<h5 class="widget-preview--action-text">{this.$t('chat_now')}</h5>
					</div>
				</div>
			)
		},

		renderMessagePreview (ev, defmsg) {
			defmsg = defmsg || 'Sent you a message'

			let message = sb.get(ev, 'data.message.text')
			var format = sb.get(ev, 'data.message.format')

			// cant display message
			if (format && format !== 'plaintext') message = defmsg
			if (!message && sb.size(sb.get(ev, 'data.message.attachments')) > 0) message = defmsg

			if (!message) return null
			let byType = sb.get(ev, 'by.type')
			var tags = sb.extractText(message).map((tag, index) => {
				if (tag.type === 'emoji') return this.renderEmoji(index, tag.text, byType)
				return tag.text
			})

			return tags
		},

		renderEmoji (key, emojiCode, byType) {
			// not an emoji
			if (sb.size(emojiCode) < 3) return null
			var emojiText = emojiCode.replace(/:/g, '')
			// use i tag instead of img, because img without src has a border (can't be styled)
			return <i data-tooltip={emojiCode} class={`emoji emoji--${emojiText}`} />
		},

		closePreview (time) {
			this.previewClosed = true
		},
	},
}

function randomAgent (agentM) {
	return agentM[Object.keys(agentM)[Math.floor(Math.random() * sb.size(agentM))]]
}
